import * as yup from 'yup';
import config from 'core/config';
import capency from 'helpers/capency';
const codeRegexp = /^[\w]{2,}$/;
const phoneRegexp = /^[0-9- _()]+$/;
const expirationRegexp = /^((0[1-9])|(1[0-2]))\/[0-9]{2}$/;
const nameRegexp = /^[A-z\u00C0-\u00ff\s'\-()]*$/;
const latinRegexp = /^[0-9A-z\u00C0-\u00ff\s'.,-/#!$%^&*;:{}=\-_`~()]*$/;
const passwordRegexp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^a-zA-Z0-9])(?=.{8,})/;
const { errors = {} } = config;
yup.setLocale({
    mixed: {
        default: errors.invalid,
        notType: errors.invalid,
        required: errors.required
    },
    number: {
        min: errors.invalid,
        max: errors.invalid
    },
    string: {
        email: errors.email,
        min: errors.invalid,
        max: errors.invalid,
        matches: errors.invalid
    }
});
const validators = {
    address: yup.string().matches(latinRegexp, errors.latin),
    name: yup.string().matches(nameRegexp, errors.latin),
    email: yup.string().email(),
    capencyMail: yup.string().test(async (value, ctx) => {
        if (ctx.options.context.ignoreCapency)
            return true;
        if (!value)
            return true;
        try {
            const check = await capency.checkMail(value);
            if (check.error)
                return ctx.createError({ message: check.message });
            else
                return true;
        }
        catch (e) {
            return true;
        }
    }),
    expirationcard: yup.string().matches(expirationRegexp),
    code: yup.string().matches(codeRegexp),
    password: yup.string().matches(passwordRegexp, errors.password),
    // day: yup.lazy((v) => (v === '' ? yup.string() : )),
    // month: yup.lazy((v) => (v === '' ? yup.string() : yup.number().min(1).max(12))),
    // year: yup.lazy((v) => (v === '' ? yup.string() : yup.number().min(1900).max(2030))),
    city: yup.string().matches(latinRegexp, errors.latin),
    street: yup.string().matches(latinRegexp, errors.latin),
    string: yup.string(),
    phonecode: yup.string(),
    phone: yup.string().min(5).matches(phoneRegexp),
    capencyPhone: yup.string().test(async (value, ctx) => {
        if (ctx.options.context.ignoreCapency)
            return true;
        if (!value)
            return true;
        const parentEntries = Object.entries(ctx.parent);
        const country = parentEntries.find((entry) => entry[0].includes('phone_code'))?.[1];
        try {
            const check = await capency.checkPhone(value, country);
            if (check.error)
                return ctx.createError({ message: check.message });
            return true;
        }
        catch (e) {
            return true;
        }
    }),
    required: (v) => (v || yup.string()).required(),
    bool: (() => {
        const bool = yup.bool();
        bool.required = () => bool.oneOf([true]);
        return bool;
    })()
};
validators.passwordConfirm = validators.password.oneOf([yup.ref('password'), yup.ref('new-password'), null], errors.confirmPassword);
validators.passwordConfirmQuiet = validators.string.oneOf([yup.ref('password'), yup.ref('new-password'), null], errors.confirmPassword);
validators.day = yup.mixed().when(['$month', '$year'], {
    is: (month, year) => (!!month || !!year),
    then: () => yup.number().min(1).max(31)
});
validators.month = yup.mixed().when(['$day', '$year'], {
    is: (day, year) => (!!day || !!year),
    then: () => yup.number().min(1).max(12)
});
validators.year = yup.mixed().when(['$month', '$day'], {
    is: (month, day) => (!!month || !!day),
    then: () => yup.number().min(1900).max(2030)
});
export default validators;
